export default "__VITE_ASSET__IR2Jf2Ef__"